import client from "@/api/client"
import axios from "axios"
import { useMutation } from "react-query"

const useFileManager = () => {
  const url = process.env.NEXT_PUBLIC_API_URL + "/upload"

  const { mutateAsync: uploadFile, isLoading: isUploading } = useMutation(
    "upload-file",
    (file: File) => {
      const formData = new FormData()
      formData.append(`files`, file)
      //Client API doesn't recognise upload route for now
      return axios.post(url, formData).then(function (response) {
        return response?.data[0]
      })
    }
  )

  const { mutateAsync: deleteFile, isLoading: isDeleting } = useMutation(
    "delete-file",
    (fileId: number) => client.upload.deleteUploadFilesId(fileId)
  )

  const createOrUpdateFile = async ({
    initialFileId,
    fileId,
    newFile,
  }: {
    initialFileId?: number
    fileId?: number
    newFile?: File
  }) => {
    let imageId = fileId
    const hasDeletedIllustration = initialFileId && !fileId
    if (hasDeletedIllustration) {
      await deleteFile(initialFileId)
      imageId = undefined
    }

    if (newFile) {
      await uploadFile(newFile).then((data) => {
        imageId = data?.id
      })
    }

    return imageId
  }

  return {
    uploadFile,
    isUploading,
    deleteFile,
    isDeleting,
    createOrUpdateFile,
    isCreatingOrUploadingFile: isUploading || isDeleting,
  }
}

export default useFileManager
